<template>
  <div>
    <label>Patient Height</label>
    <div class="inputs-container">
      <md-field v-if="conversionMultiplier.mainUnit">
        <md-input
          type="number"
          :value="convertedHeight.mainUnit"
          :disabled="readonly"
          @input="(value) => updateMainUnit(value)"
        />
        <span class="unit"> {{ unit.mainUnit }}. </span>
      </md-field>
      <md-field>
        <md-input
          type="number"
          :value="convertedHeight.subUnit"
          :disabled="readonly"
          @input="(value) => updateSubUnit(value)"
        />
        <span class="unit"> {{ unit.subUnit }}. </span>
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  name: 'patient-height-input',
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    convertedHeight() {
      const { height } = this.caseConf.initialConditions;
      if (height === null || height === undefined) {
        return {
          mainUnit: null,
          subUnit: null,
        };
      }
      if (!this.conversionMultiplier.mainUnit) {
        return {
          subUnit: Math.round(height * this.conversionMultiplier.subUnit),
        };
      }
      const heightInMainUnit = height * this.conversionMultiplier.mainUnit;
      const fractionalInMainUnit = heightInMainUnit % 1;

      const mainUnit = Math.floor(heightInMainUnit);
      const subUnit = Math.round(
        (fractionalInMainUnit / this.conversionMultiplier.mainUnit) *
          this.conversionMultiplier.subUnit
      );
      return {
        mainUnit,
        subUnit,
      };
    },
    conversionMultiplier() {
      const { measurementSystem } = this.caseConf;
      if (measurementSystem === 'IMPERIAL') {
        return {
          // cm to ft
          mainUnit: 0.0328084,
          // cm to inches
          subUnit: 0.393701,
        };
      }
      return {
        // Don't display meters
        mainUnit: null,
        // cm to cm
        subUnit: 1,
      };
    },
    unit() {
      const { measurementSystem } = this.caseConf;
      if (measurementSystem === 'IMPERIAL') {
        return {
          mainUnit: 'ft',
          subUnit: 'in',
        };
      }
      return {
        mainUnit: 'm',
        subUnit: 'cm',
      };
    },
  },
  methods: {
    updateMainUnit(value) {
      const height =
        value / this.conversionMultiplier.mainUnit +
        this.convertedHeight.subUnit / this.conversionMultiplier.subUnit;
      this.updateHeight(height);
    },
    updateSubUnit(value) {
      let height;
      if (this.conversionMultiplier.mainUnit) {
        height =
          this.convertedHeight.mainUnit / this.conversionMultiplier.mainUnit +
          value / this.conversionMultiplier.subUnit;
      } else {
        height = value / this.conversionMultiplier.subUnit;
      }
      this.updateHeight(height);
    },
    updateHeight(height) {
      this.$emit('update', {
        initialConditions: {
          height,
        },
      });
    },
  },
};
</script>

<style scoped>
.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.md-field + .md-field {
  margin-top: 0;
}

.md-field input {
  width: 52px;
  padding: 0 !important;
  padding-left: 10px !important;
  text-align: center;
}

.unit {
  color: #2b2b2b;
  font-size: 16px;
  line-height: 20px;
  margin-left: 8px;
}
</style>